import React from "react";
import { Col, Row } from "react-bootstrap";
import { DataContext } from "../../App";
import Spinner from "react-bootstrap/Spinner";
import { Loader, LoaderThemeColor } from "@progress/kendo-react-indicators";
import { Policy } from "../Cards/Policy";
import Container from "react-bootstrap/Container";
import { Counter } from "../Others/CountDown";
import { RiskInformation } from "../Cards/RiskInformation/RiskInformation";
import { ModalInformation } from "../Alerts/PopUpComunication";
import { MostrarAlerta } from "../Alerts/Terms";
import { WAITPOLICIESTIME } from "../../Utils/variables";
import "./PolicyList.css";

export default function PolicyList({
  setPoliciesCompare,
  setDetails,
  data,
  idOportunity,
  policySelectedContext,
}) {
  const { context } = React.useContext(DataContext);
  const wait_time =
    WAITPOLICIESTIME[context?.oportunity?.risk_in?.business_line] ||
    WAITPOLICIESTIME.default;
  const [loadingQuotes, setLoadingQuotes] = React.useState(true);
  const [selected, setSelected] = React.useState(() => {
    var indexes = [];
    var idbds = [];
    policySelectedContext.forEach((element) => {
      idbds.push(element.id_db);
    });
    context.policies.map((item, index) => {
      if (idbds.includes(item.id_db)) indexes.push(index);
    });
    return indexes;
  });
  const [policySelected, setPolicySelected] = React.useState(
    policySelectedContext
  );
  const [showRedirectHome, setShowRedirectHome] = React.useState(false);
  const [isOpenAlert, setIsOpenAlert] = React.useState(false);

  const onRedirectHome = (e) => {
    window.location.replace(`https://${window.location.host}`);
  };
  React.useEffect(() => {
    setPolicySelected(
      context.policies.filter((item, index) => selected.includes(index))
    );
  }, [selected]);

  const setDetailsPolicy = (policy) => {
    setDetails([policy]);
  };

  React.useEffect(() => {
    setPoliciesCompare(policySelected);
  }, [policySelected]);

  React.useEffect(() => {
    setTimeout(() => {
      if (context.policies.length == 0) {
        setShowRedirectHome(true);
      }
      setLoadingQuotes(false);
    }, wait_time);
  }, []);

  function openAlert() {
    setIsOpenAlert(true);
  }

  function closeAlert() {
    setIsOpenAlert(false);
  }

  return context.policies.length > 0 ? (
    <React.Fragment>
      <Container className="policies-container">
        <Row
          className="justify-content-center mt-2 col-row-correction"
          key={"info"}
          variant={"info"}
        >
          <RiskInformation oportunity={context.oportunity}></RiskInformation>
        </Row>
        <MostrarAlerta isOpen={isOpenAlert} closeAlert={closeAlert} />
        <Row
          className="justify-content-center mt-3"
          key={"infoCot"}
          variant={"info"}
        >
          <span className="text-center mb-0 principal-title">
            Estas son las cotizaciones que hemos encontrado para ti
          </span>
        </Row>
        <Row className="justify-content-center mt-0 cards-container">
          {context.policies.map((item, index) => {
            return (
              <Col
                lg={4}
                md={4}
                sm={6}
                key={index}
                style={{ padding: "0.8rem 0.8rem" }}
              >
                <Policy
                  policy={item}
                  index={index}
                  key={index}
                  selected={selected}
                  setDetailsPolicy={setDetailsPolicy}
                  setSelected={setSelected}
                />
              </Col>
            );
          })}
        </Row>
        {loadingQuotes ? (
          <Row className="justify-content-center mt-3">
            <Spinner animation="border" variant="primary" />
          </Row>
        ) : null}
        <Row className="mt-3 terms">
          <Col xs={12}>
            <p align="start" style={{ marginBottom: "0.5em" }}>
              <span style={{ textAlign: "center" }}>
                <strong>IMPORTANTE:</strong>
              </span>
            </p>
            <p style={{ marginBottom: "0em" }}>
              <strong>
                Estas cotizaciones son provisionales y no implica aceptación del
                riesgo, las condiciones, coberturas y precios están sujetas a
                cambios de acuerdo a políticas y condiciones de las aseguradoras
                o cambios de información.
              </strong>{" "}
              <span className="redirect-quote-click" onClick={openAlert}>
                Click aquí para ver mas información
              </span>
            </p>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  ) : !showRedirectHome ? (
    <div id="FinalStep">
      <Row className="justify-content-center mt-5">
        <h4 className="text-center">
          Estamos cargando tus cotizaciones <Loader themeColor={"dark"} />
        </h4>
      </Row>
      <Row className="justify-content-center">
        <h4 className="text-center">
          <Counter initialCount={wait_time}></Counter>
        </h4>
      </Row>
    </div>
  ) : (
    <ModalInformation show={true} redirect={onRedirectHome}></ModalInformation>
  );
}
